import React from 'react';
import Works from './Works';

const WorkResult = props => <Works isWorkSchedule={false} {...props} />;

export default WorkResult;



// WEBPACK FOOTER //
// ./src/pages/WorkResult.jsx